import React from 'react'
import { useStore, useSettings } from '../../state/store'
import CollapsibleSection from './CollapsibleSection'

const HalftoneParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="slider-container">
        <span className="slider-label">大小</span>
        <input type="range" min="0.4" max="2.2" step="0.1" value={settings.halftoneSize} onChange={(e) => updateSettings({ halftoneSize: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.halftoneSize.toFixed(1)}</span>
      </div>
      <div className="xp-checkbox-row">
        <span className="xp-field-label">形状</span>
        <select value={settings.halftoneShape} onChange={(e) => updateSettings({ halftoneShape: e.target.value as any })} className="w-36">
          <option value="circle">圆形</option>
          <option value="square">方形</option>
          <option value="diamond">菱形</option>
          <option value="pentagon">五边形</option>
          <option value="hexagon">六边形</option>
        </select>
      </div>
      <div className="slider-container">
        <span className="slider-label">旋转</span>
        <input type="range" min="-180" max="180" step="5" value={settings.halftoneRotation} onChange={(e) => updateSettings({ halftoneRotation: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.halftoneRotation}°</span>
      </div>
    </div>
  )
}

const DitherParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="xp-checkbox-row">
        <span className="xp-field-label">抖动算法</span>
        <select value={settings.ditherType} onChange={(e) => updateSettings({ ditherType: e.target.value as any })} className="w-36">
          <option value="none">无</option>
          <option value="floyd-steinberg">Floyd-Steinberg</option>
          <option value="bayer">Bayer</option>
          <option value="atkinson">Atkinson</option>
        </select>
      </div>
      <div className="slider-container">
        <span className="slider-label">强度</span>
        <input type="range" min="0" max="1" step="0.05" value={settings.ditherStrength} onChange={(e) => updateSettings({ ditherStrength: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.ditherStrength.toFixed(2)}</span>
      </div>
      <div className="slider-container">
        <span className="slider-label">颜色数</span>
        <input type="range" min="2" max="8" step="1" value={settings.ditherColorNum} onChange={(e) => updateSettings({ ditherColorNum: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.ditherColorNum}</span>
      </div>
    </div>
  )
}

const RetroParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="xp-checkbox-row">
        <span className="xp-field-label">双色调</span>
        <select value={settings.retroDuotone} onChange={(e) => updateSettings({ retroDuotone: e.target.value as any })} className="w-36">
          <option value="amber-classic">琥珀经典</option>
          <option value="cyan-night">青色夜空</option>
          <option value="violet-haze">紫色迷雾</option>
          <option value="lime-pulse">青柠脉冲</option>
          <option value="mono-ice">冰蓝单色</option>
        </select>
      </div>
      <div className="slider-container">
        <span className="slider-label">噪点</span>
        <input type="range" min="0" max="1" step="0.05" value={settings.retroNoise} onChange={(e) => updateSettings({ retroNoise: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.retroNoise.toFixed(2)}</span>
      </div>
    </div>
  )
}

const LineParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="slider-container">
        <span className="slider-label">长度</span>
        <input type="range" min="0.5" max="3" step="0.1" value={settings.lineLength} onChange={(e) => updateSettings({ lineLength: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.lineLength.toFixed(1)}</span>
      </div>
      <div className="slider-container">
        <span className="slider-label">宽度</span>
        <input type="range" min="0.5" max="3" step="0.1" value={settings.lineWidth} onChange={(e) => updateSettings({ lineWidth: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.lineWidth.toFixed(1)}</span>
      </div>
      <div className="slider-container">
        <span className="slider-label">粗细</span>
        <input type="range" min="0.5" max="5" step="0.1" value={settings.lineThickness} onChange={(e) => updateSettings({ lineThickness: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.lineThickness.toFixed(1)}</span>
      </div>
      <div className="slider-container">
        <span className="slider-label">旋转</span>
        <input type="range" min="-180" max="180" step="5" value={settings.lineRotation} onChange={(e) => updateSettings({ lineRotation: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.lineRotation}°</span>
      </div>
    </div>
  )
}

const ParticlesParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="slider-container">
        <span className="slider-label">密度</span>
        <input type="range" min="0" max="1" step="0.05" value={settings.particleDensity} onChange={(e) => updateSettings({ particleDensity: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.particleDensity.toFixed(2)}</span>
      </div>
      <div className="xp-checkbox-row">
        <span className="xp-field-label">字符</span>
        <input type="text" value={settings.particleChar} onChange={(e) => updateSettings({ particleChar: e.target.value })} className="w-16 text-center" maxLength={1} />
      </div>
    </div>
  )
}

const ClaudeParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="slider-container">
        <span className="slider-label">密度</span>
        <input type="range" min="0" max="1" step="0.05" value={settings.claudeDensity} onChange={(e) => updateSettings({ claudeDensity: Number(e.target.value) })} className="flex-1" />
        <span className="slider-value">{settings.claudeDensity.toFixed(2)}</span>
      </div>
    </div>
  )
}

const TerminalParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="xp-checkbox-row">
        <span className="xp-field-label">字符集</span>
        <select value={settings.terminalCharset} onChange={(e) => updateSettings({ terminalCharset: e.target.value as any })} className="w-36">
          <option value="binary">二进制</option>
          <option value="brackets">括号</option>
          <option value="symbols">符号</option>
          <option value="mixed">混合</option>
          <option value="matrix">Matrix</option>
        </select>
      </div>
    </div>
  )
}

const BrailleParams: React.FC = () => {
  const { settings, updateSettings } = useStore()
  return (
    <div className="space-y-2">
      <div className="xp-checkbox-row">
        <span className="xp-field-label">变体</span>
        <select value={settings.brailleVariant} onChange={(e) => updateSettings({ brailleVariant: e.target.value as any })} className="w-36">
          <option value="standard">标准</option>
          <option value="sparse">稀疏</option>
          <option value="dense">密集</option>
        </select>
      </div>
    </div>
  )
}

const EngineParamsPanel: React.FC = () => {
  const settings = useSettings()

  const renderParams = () => {
    switch (settings.style) {
      case 'halftone':
        return <HalftoneParams />
      case 'dither':
      case 'dither2':
        return <DitherParams />
      case 'retro':
        return <RetroParams />
      case 'line':
        return <LineParams />
      case 'particles':
        return <ParticlesParams />
      case 'claude':
        return <ClaudeParams />
      case 'terminal':
        return <TerminalParams />
      case 'braille':
        return <BrailleParams />
      default:
        return <div className="xp-note">当前风格没有额外引擎参数。</div>
    }
  }

  return (
    <CollapsibleSection title="引擎参数" icon="ENG" defaultExpanded={false}>
      {renderParams()}
    </CollapsibleSection>
  )
}

export default EngineParamsPanel
